/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefiltermissing3Inputs */

const en_ticketpagefiltermissing3 = /** @type {(inputs: Ticketpagefiltermissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not here yet`)
};

const de_ticketpagefiltermissing3 = /** @type {(inputs: Ticketpagefiltermissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht da`)
};

/**
* | output |
* | --- |
* | "Not here yet" |
*
* @param {Ticketpagefiltermissing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefiltermissing3 = /** @type {((inputs?: Ticketpagefiltermissing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefiltermissing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefiltermissing3(inputs)
	return de_ticketpagefiltermissing3(inputs)
});
export { ticketpagefiltermissing3 as "ticketPageFilterMissing" }